
















import AbpBase from "@/lib/abpbase";
import { Component, Prop } from "vue-property-decorator";
import formBuilder from "@/components/formBuilder/index.vue";
import { GetFormSetting, SaveFormSetting } from "@/api/assessForm";

@Component({
  components: { formBuilder },
})
export default class extends AbpBase {
  @Prop() data: any;
  @Prop() value: boolean;
  loading = false;
  formData: any = {
    list: [],
    config: {
      name: "",
      labelWidth: 100,
      labelPosition: "right",
      size: "default",
    },
  };

  created() {
    if (this.data.mode == "edit") {
      this.getData("");
    }
  }

  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }

  cancel() {
    this.$emit("input", false);
  }

  async getData(type:string) {
    this.loading = true;
    var formName = type =="Save"?this.formData.config.name:this.data.model.name;
    let res = await GetFormSetting({ formName: formName,saveType:type });
    this.formData = res.data;
    if (this.formData) {
      this.formData.list.forEach((item) => {
        if (item.type == "checkbox") {
          item.defaultValue =
            item.defaultValue != null ? item.defaultValue.split(",") : "";
        } else {
          if (item.type == "grid") {
            item.columns.forEach((col) => {
              col.list.forEach((citem) => {
                if (citem.type == "checkbox") {
                  citem.defaultValue =
                    citem.defaultValue != null
                      ? citem.defaultValue.split(",")
                      : "";
                }
              });
            });
          }
        }
      });
    }
    this.loading = false;
  }

  async save(resData:any) {
    console.log(resData);
    if (!resData.config.name) {
      this.$Message.error("请输入表单名称");
      return;
    }
    if (resData.list.length == 0) {
      this.$Message.error("请先拖拽组件");
      return;
    }
    this.loading = true;
    try {
      let res = await SaveFormSetting(resData);
      if (res.code === 2000) {
        this.$Message.success("保存成功");
        this.getData("Save")
        this.$emit("save-success");
/*         this.$emit("input", false); */
      }
    } catch (error) {
      console.error(error);
    }
    this.loading = false;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/tool/formBuilder/addOrEdit.vue